import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../shared/http-client';
import { Button } from '../../elements/button';
import MileageBarChart from './MileageBarChart';
import ConsumptionBarChart from './ConsumptionBarChart';


export const MileageControl = () => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [vehicles, setVehicles] = useState<any[]>([]);
    const currentYear = dayjs().year();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [backendChartData, setBackendChartData] = useState<any[]>([]);
    const [show1, setShow1] = useState(true);
    const [totalKm, setTotalKm] = useState(0);
    const [totalConsumo, setTotalConsumo] = useState(0);

    const months = [
        t('Enero'),
        t('Febrero'),
        t('Marzo'),
        t('Abril'),
        t('Mayo'),
        t('Junio'),
        t('Julio'),
        t('Agosto'),
        t('Septiembre'),
        t('Octubre'),
        t('Noviembre'),
        t('Diciembre')
    ];

    let obligado = {

    };
    const validacion = Yup.object().shape(obligado);

    const initialValues = {
        plate: null,
    };


    useEffect(() => {
        api('/fleet/vehicles/', 'GET');
    }, []);



    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        after.year = selectedYear;

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);



        if (enviaremos.plate) {
            api(`/fleet/vehicle-monthly-metrics/?year=${selectedYear}&vehicle=${enviaremos.plate}`, 'GET');
        } else {
            api(`/fleet/vehicle-monthly-metrics/?year=${selectedYear}`, 'GET');
        }
    };

    const handleShow1 = () => {
        setShow1(true);
    };

    const handleShow2 = () => {
        setShow1(false);
    };


    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
            }
        }
        if (state.data && state.path.includes('vehicle-monthly-metrics')) {
            const transformedData = Object.keys(state.data.monthly_data).map(key => ({
                month: parseInt(key, 10),
                odometry: state.data.monthly_data[key].odometry,
                total_fuel_used: state.data.monthly_data[key].total_fuel_used || 0,
                //total_fuel_used: state.data.monthly_data[key].total_fuel_used || 0
            }));
            setBackendChartData(transformedData);
            setTotalKm(state.data.year_total_odometer)
            setTotalConsumo(state.data.year_total_fuel)
        }

        if (state.error) {
            if (state.error.error?.includes('No vehicle assignments found for driver')) {
                toast.error(`${t('common.error.driver-not-asigned')}`);
            }
        }
    }, [state.data]);

    return (
        <div className="relative z-10">
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validacion}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({ values, errors, touched, setFieldValue, handleSubmit }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="px-8 pt-4 text-[22px] text-gray-900">
                            {t('common.form-label.estadisticas-mensuales')}
                        </div>
                        <div className="px-8 pt-4">
                            <div className="flex justify-start">
                                <div className="pb-8 w-[300px]">
                                    <label className="text-gray-700 font-semibold text-sm mr-[33px] mt-2">
                                        {t('common.label.vehiculo')}:
                                    </label>
                                    <select
                                        value={values.plate ?? ""}
                                        onChange={e => setFieldValue('plate', e.target.value)}
                                        className="rounded-lg w-full border-gray-200"
                                    >
                                        <option value="">{t('common.label.todos')}</option>
                                        {vehicles.map(vehicle => (
                                            <option key={vehicle.id} value={vehicle.id}>
                                                {vehicle.plate}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="pb-8 w-[300px] pl-8">
                                    <label className="text-gray-700 font-semibold text-sm mr-[33px] mt-2">
                                        {t('common.label.year')}:
                                    </label>
                                    <select
                                        value={selectedYear}
                                        onChange={(e) => {
                                            setSelectedYear(Number(e.target.value));

                                        }}
                                        className="rounded-lg w-full border-gray-200"
                                    >
                                        {Array.from(
                                            { length: 21 },
                                            (_, i) => currentYear - 10 + i
                                        ).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="pl-8 pt-8">
                                    <Button
                                        label={t('common.button.search')}
                                        onClick={handleSubmit}
                                        disabled={state.loading}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex w-1/2 pl-8'>
                            <div className=''><Button
                                onClick={handleShow1}
                                label={t('common.form-label.kilometraje-mensual')}
                                variant={!show1 ? 'gray' : 'primary'}
                            /></div>
                            <div className='pl-8'><Button
                                onClick={handleShow2}
                                label={t('common.form-label.consumo-mensual')}
                                variant={show1 ? 'gray' : 'primary'}
                            /></div>
                        </div>
                    </form>
                )}
            </Formik>

            {backendChartData.length > 0 && (
                <>
                    {show1 ? <div className='text-[14px] pt-4 pl-8'>{t('common.label.total-kilometros')}: {totalKm/1000} Km</div> : <div className='text-[14px] pt-4 pl-8'>{t('common.label.total-consumo')}: {totalConsumo} L</div>}
                    <div className="w-full pt-8 pb-2">
                        {show1 ? <MileageBarChart months={months} datos={backendChartData} tooltipLabel={t('Kilometraje')} /> : <ConsumptionBarChart months={months} datos={backendChartData} tooltipLabel={t('common.form-label.consumo')} />}
                    </div>
                </>

            )}
        </div>
    );


};